import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import {
  map, Observable,
  ComparisonReportClubProgramDataWithPayment, ComparisonReportSession, ComparisonReport, ScholarshipReport, CreditReport, CCDeclinedReport,
  DiscountReport, CCExpiredReport, InCompleteReport, RefundReport, PayoutReport, TeamRegistrationReport, FinancialsReport, UserScholarshipReport
} from '../models';
import { DisputeReportUserListData } from '../models/reports/dispute-report';

@Injectable()
export class DisputesService {

  private _url = '/api/disputes';

  constructor(private httpService: HttpService) { }

  // -------------- Submit Dispute -------------- //
  submitDispute(payload: any) {
    return this.httpService.post(this._url + '/submit-new-dispute', { payload: payload });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/disputes.service.ts